module.exports = __webpack_public_path__ + "img/icone_corte_de_cabo_vermelho.ff2f661f.png";